var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreview1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 0C3.80561 0 0 3.80561 0 8.5C0 13.1944 3.80561 17 8.5 17C13.1947 17 17 13.1944 17 8.5C17 3.80561 13.1947 0 8.5 0ZM8.5 15.3C4.75047 15.3 1.7 12.2495 1.7 8.5C1.7 4.75047 4.75047 1.7 8.5 1.7C12.2495 1.7 15.3 4.75047 15.3 8.5C15.3 12.2495 12.2495 15.3 8.5 15.3Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5916 7.90436L7.46943 5.52436C6.90265 5.19728 6.4389 5.46486 6.4389 6.11936V10.8794C6.4389 11.5339 6.90265 11.8018 7.46943 11.4744L11.5916 9.09436C12.1584 8.76728 12.1584 8.23145 11.5916 7.90436Z",
    fill: "#969696"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview1);
export default __webpack_public_path__ + "static/media/Preview_1.6599f4e9e81b1eff8d71403e2e5494da.svg";
export { ForwardRef as ReactComponent };